export const AppPaths = Object.freeze({
  chat: "/chat",
  login: "/login",
});

/** 只规范两个公开入口，其他路径保持现状，避免把未知路径误当成登录页。 */
export function correctedAppPath(pathname: string, authenticated: boolean): string | null {
  if (authenticated && pathname === AppPaths.login) return AppPaths.chat;
  if (!authenticated && pathname === AppPaths.chat) return AppPaths.login;
  return null;
}

export function replaceAppPath(pathname: string): void {
  if (window.location.pathname === pathname) return;
  window.history.replaceState(null, "", pathname);
}
